import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { AppProvider, Page } from '@shopify/polaris';
import createApp from '@shopify/app-bridge';
import { Provider } from '@shopify/app-bridge-react';
import Installing from './Installing';
import Index from './Index';
import configureStore from '../../configureStore';

export default class Admin extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    const app = createApp({
      apiKey: this.props.apiKey,
      host: this.props.host,
    });
    window.app = app;
    const initialState = {
      shop: this.props.shop,
      wallConfig: this.props.wallConfig,
      backgrounds: this.props.backgrounds,
      frames: this.props.frames,
      faqs: this.props.faqs,
      settings: {
        apiKey: this.props.apiKey,
        host: this.props.host,
        appName: this.props.appName,
        appDomain: this.props.appDomain
      },
    }

    const store = configureStore(initialState);
    let shopHost = this.props.shop.shopify_domain + '/admin';
    const config = {
      apiKey: this.props.apiKey,
      shopOrigin: this.props.shop.shopify_domain,
      host: Buffer.from(shopHost).toString('base64'),
      forceRedirect: true
    }

    return(
      <ReduxProvider store={store}>
        <Provider config={config}>
          <AppProvider>
            <BrowserRouter>
              <Switch>
                <Route exact path="/installing" component={Installing} />
                <Route exact path="/" render={() => (
                  store.getState().shop.status == "installing" ?
                  (<Redirect to="/installing" />) :
                  (<Index />)
                )} />
              </Switch>
            </BrowserRouter>
          </AppProvider>
        </Provider>
      </ReduxProvider>
    )
  }
}

